<template>
  <scroll-bar>
    <!-- 侧边栏 LOGO -->
    <div class="sidebar-logo">
      <svg-icon icon-class="login-mall" class="sidebar-logo__icon"></svg-icon>
      <span class="sidebar-logo__text" v-show="sidebar.opened">商城管理系统</span>
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="transparent"
      text-color="rgba(255, 255, 255, 0.7)"
      active-text-color="#ffffff"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.05);

  &__icon {
    width: 28px;
    height: 28px;
    color: #ffffff;
    flex-shrink: 0;
  }

  &__text {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    letter-spacing: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue